// extracted by mini-css-extract-plugin
export default {"container":"Input_container__ngyzB","input":"Input_input__ec7Id","prefix":"Input_prefix__NsAW7","suffix":"Input_suffix__peyDE"};